import { Component, Input, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DispatchTransporteurDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-dispatch-transporteur',
  templateUrl: './dispatch-transporteur.component.html',
  styleUrls: ['./dispatch-transporteur.component.css']
})
export class DispatchTransporteurComponent implements OnInit {
  @Select(ControlPanelStore.dispatchTransporteurs$) dispatchTransporteurs$: Observable<DispatchTransporteurDto[]>;

  private _dispatchTransporteurId: number = null;
  DispatchTransporteurs: DispatchTransporteurDto[] = [];

  @Input()
  get dispatchTransporteurId() {
    return this._dispatchTransporteurId;
  }
  set dispatchTransporteurId(val) {
    this._dispatchTransporteurId = val;
    this.getDispatchTransporteurInComponent();
  }

  DispatchTransporteurInComponent: string;

  dt: Subscription;

  constructor() { }

  ngOnInit() {
    this.dt = this.dispatchTransporteurs$.subscribe(res => {
      if (res != null) {
        this.DispatchTransporteurs = res;
        this.getDispatchTransporteurInComponent();
      }
    });
  }

  getDispatchTransporteurInComponent() {
    let dispatchTransporteur = this.DispatchTransporteurs.find(p => p.Id == this.dispatchTransporteurId);
    this.DispatchTransporteurInComponent = (dispatchTransporteur) ? dispatchTransporteur.Identifiant : null;
  }

  ngOnDestroy() {
    this.dt?.unsubscribe();
  }

}
